import { render, staticRenderFns } from "./FCDashboardTableExpansion.vue?vue&type=template&id=5b3af66c&scoped=true&"
import script from "./FCDashboardTableExpansion.vue?vue&type=script&lang=js&"
export * from "./FCDashboardTableExpansion.vue?vue&type=script&lang=js&"
import style0 from "./FCDashboardTableExpansion.vue?vue&type=style&index=0&id=5b3af66c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3af66c",
  null
  
)

export default component.exports